import React, { useState } from "react";
import { useGame } from "../context/GameContext";
import { useTimer } from "../hooks/useTimer";

const AVATARS = [
  { emoji: "🦊", bg: "#ff3e3e22", border: "#ff3e3e", text: "#ff3e3e" },
  { emoji: "👾", bg: "#9b6dff22", border: "#9b6dff", text: "#9b6dff" },
  { emoji: "🦖", bg: "#3effa322", border: "#3effa3", text: "#3effa3" },
  { emoji: "🐱", bg: "#f5c84222", border: "#f5c842", text: "#f5c842" },
  { emoji: "🦁", bg: "#ff6b3e22", border: "#ff6b3e", text: "#ff6b3e" },
  { emoji: "🐧", bg: "#3eaaff22", border: "#3eaaff", text: "#3eaaff" },
  { emoji: "🐷", bg: "#ff3eb522", border: "#ff3eb5", text: "#ff3eb5" },
  { emoji: "🐬", bg: "#3effee22", border: "#3effee", text: "#3effee" },
  { emoji: "👽", bg: "#aaff3e22", border: "#aaff3e", text: "#aaff3e" },
  { emoji: "👻", bg: "#ffffff22", border: "#ffffff", text: "#ffffff" },
];
const CIRCUMFERENCE = 2 * Math.PI * 24;
const INFO_GRUPO = {
  A: { cor: "#3effa3", dim: "rgba(62,255,163,0.15)", label: "Facção A", emoji: "🟢" },
  B: { cor: "#3eaaff", dim: "rgba(62,170,255,0.12)", label: "Facção B", emoji: "🔵" },
  impostor: { cor: "#ff3e3e", dim: "rgba(255,62,62,0.15)", label: "Impostor", emoji: "🕵️" },
};

export function FaccaoRevealScreen() {
  const { jogadores, jogadorAtualIdx, faccaoJogadores, faccaoAtual, avancarRevealFaccao, rodada } = useGame();
  const [revelado, setRevelado] = useState(false);
  const [passando, setPassando] = useState(false);
  const nome = jogadores[jogadorAtualIdx];
  const grupo = faccaoJogadores[jogadorAtualIdx];
  const av = AVATARS[jogadorAtualIdx % AVATARS.length];
  const info = INFO_GRUPO[grupo] || INFO_GRUPO.A;
  const ehImp = grupo === "impostor";

  const getPalavra = () => {
    if (ehImp) return faccaoAtual?.impostor || "???";
    if (grupo === "A") return faccaoAtual?.grupoA;
    return faccaoAtual?.grupoB;
  };

  const continuar = () => {
    setPassando(true);
    setTimeout(() => { setRevelado(false); setPassando(false); avancarRevealFaccao(); }, 350);
  };

  if (!revelado) return (
    <div className="app-wrapper" style={{ paddingTop: 80 }}>
      <div style={{ textAlign: "center", marginBottom: 32, animation: "slideUp 0.4s ease" }}>
        <div style={{ color: "var(--text-muted)", fontSize: "0.75rem", textTransform: "uppercase", marginBottom: 8 }}>
          Rodada {rodada} · Jogador {jogadorAtualIdx + 1} de {jogadores.length}
        </div>
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: av.bg, border: `3px solid ${av.border}`, color: av.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2.8rem", margin: "0 auto 16px", boxShadow: `0 0 30px ${av.border}44` }}>{av.emoji}</div>
        <div style={{ fontFamily: "'Bebas Neue'", fontSize: "2rem" }}>{nome}</div>
        <div style={{ color: "var(--text-secondary)", fontSize: "0.9rem", marginTop: 6 }}>Passe o dispositivo para este jogador</div>
      </div>
      <div className="card" style={{ maxWidth: 400 }}>
        <div className="card-body" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: 16 }}>⚔️</div>
          <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem", lineHeight: 1.6, marginBottom: 24 }}>
            Apenas <strong style={{ color: "var(--text-primary)" }}>{nome}</strong> deve estar olhando.<br /><br />
            Toque para ver sua <strong style={{ color: "var(--text-primary)" }}>Facção Secreta</strong>.
          </p>
          <button className="btn btn-primary btn-full" onClick={() => setRevelado(true)}>🔓 Revelar minha facção</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, opacity: passando ? 0 : 1, transition: "opacity 0.3s" }}>
      <div className="card" style={{ maxWidth: 500 }}>
        <div className="card-header">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: av.bg, border: `2px solid ${av.border}`, color: av.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem" }}>{av.emoji}</div>
            <span style={{ background: info.dim, border: `1px solid ${info.cor}`, color: info.cor, borderRadius: 8, padding: "4px 12px", fontSize: "0.78rem", fontFamily: "'Space Mono'" }}>
              {info.emoji} {info.label}
            </span>
          </div>
          <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.6rem" }}>{nome}</div>
        </div>
        <div className="card-body">
          <div className="question-box" style={{ textAlign: "center", padding: "28px 20px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 12 }}>
              {ehImp ? "🕵️ Sua palavra (impostor)" : `${info.emoji} Palavra da ${info.label}`}
            </div>
            <div style={{ fontSize: "2.6rem", fontFamily: "'Bebas Neue'", color: info.cor }}>{getPalavra()}</div>
          </div>
          <div style={{ marginTop: 16, padding: 14, background: "var(--bg-elevated)", borderRadius: 10, fontSize: "0.82rem", color: "var(--text-secondary)", lineHeight: 1.5 }}>
            {ehImp
              ? "⚠️ Você é o impostor! Tente descobrir as duas facções e se misturar sem ser pego!"
              : `💡 Você é da ${info.label}. Tente encontrar seus aliados sem revelar a palavra diretamente!`}
          </div>
        </div>
        <div className="card-footer">
          <button className="btn btn-primary btn-full" onClick={continuar}>
            {jogadorAtualIdx + 1 < jogadores.length ? "Próximo jogador →" : "⚔️ Iniciar discussão →"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function FaccaoDiscussaoScreen() {
  const { jogadores, timerAtivo, tempoRodada, finalizarDiscussaoFaccao, rodada, faccaoAtual } = useGame();
  const [tempoAcabou, setTempoAcabou] = useState(false);
  const { tempo, porcentagem, iniciar } = useTimer(tempoRodada, () => setTempoAcabou(true));
  React.useEffect(() => { if (timerAtivo) iniciar(); }, []);
  const timerColor = porcentagem > 60 ? "var(--green)" : porcentagem > 30 ? "var(--gold)" : "var(--accent)";

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <div className="card" style={{ maxWidth: 560 }}>
        <div className="card-header">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div className="title-eyebrow">⚔️ Duas Facções · Rodada {rodada}</div>
              <h2 className="title-main" style={{ fontSize: "2rem" }}>Encontre<br /><span style={{ color: "#3effa3" }}>seu time!</span></h2>
            </div>
            {timerAtivo && (
              <div style={{ textAlign: "center" }}>
                <svg viewBox="0 0 58 58" width="64" height="64">
                  <circle cx="29" cy="29" r="24" stroke="var(--border)" strokeWidth="4" fill="none" />
                  <circle cx="29" cy="29" r="24" stroke={timerColor} strokeWidth="4" fill="none"
                    strokeDasharray={CIRCUMFERENCE} strokeDashoffset={CIRCUMFERENCE - (CIRCUMFERENCE * porcentagem) / 100}
                    strokeLinecap="round" transform="rotate(-90 29 29)" />
                </svg>
                <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.4rem", color: timerColor, marginTop: -8 }}>{tempo}s</div>
              </div>
            )}
          </div>
        </div>
        <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ display: "flex", gap: 10 }}>
            <div style={{ flex: 1, background: "rgba(62,255,163,0.1)", border: "1px solid #3effa3", borderRadius: 12, padding: "12px 16px", textAlign: "center" }}>
              <div style={{ fontSize: "1.4rem", marginBottom: 4 }}>🟢</div>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.1rem", color: "#3effa3" }}>Facção A</div>
              <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", marginTop: 2 }}>?????</div>
            </div>
            <div style={{ flex: 1, background: "rgba(62,170,255,0.1)", border: "1px solid #3eaaff", borderRadius: 12, padding: "12px 16px", textAlign: "center" }}>
              <div style={{ fontSize: "1.4rem", marginBottom: 4 }}>🔵</div>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.1rem", color: "#3eaaff" }}>Facção B</div>
              <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", marginTop: 2 }}>?????</div>
            </div>
            <div style={{ flex: 1, background: "rgba(255,62,62,0.1)", border: "1px solid #ff3e3e", borderRadius: 12, padding: "12px 16px", textAlign: "center" }}>
              <div style={{ fontSize: "1.4rem", marginBottom: 4 }}>🕵️</div>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.1rem", color: "#ff3e3e" }}>Impostor</div>
              <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", marginTop: 2 }}>Palavra<br />diferente</div>
            </div>
          </div>
          <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "16px 20px" }}>
            <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 8 }}>💡 Como jogar</div>
            <div style={{ fontSize: "0.84rem", color: "var(--text-secondary)", lineHeight: 1.7 }}>
              • Dê dicas sobre sua palavra sem revelá-la diretamente<br />
              • Tente identificar quem é do seu time<br />
              • Identifique e vote no impostor no final<br />
              • O impostor tenta descobrir as duas palavras!
            </div>
          </div>
          {tempoAcabou && (
            <div style={{ background: "rgba(245,200,66,0.15)", border: "1px solid var(--gold)", borderRadius: 12, padding: "14px 18px", textAlign: "center" }}>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.4rem", color: "var(--gold)" }}>⏰ Tempo esgotado!</div>
            </div>
          )}
        </div>
        <div className="card-footer">
          <button className="btn btn-primary" onClick={finalizarDiscussaoFaccao}>🗳️ Votar no Impostor →</button>
        </div>
      </div>
    </div>
  );
}
